import { useState, useEffect, useCallback } from 'react';
import { useToast } from '@/components/ui/use-toast';
import { useTranslation } from 'react-i18next';

export const useConnectionStatus = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const [isOnline, setIsOnline] = useState(true);
  const [isChecking, setIsChecking] = useState(false);
  const [lastCheck, setLastCheck] = useState(Date.now());
  const [initialized, setInitialized] = useState(false);

  const checkConnection = useCallback(async () => {
    console.log('[ConnectionStatus] Health check called at:', new Date().toISOString());
    // Временно отключаем health check
    return;
    
    setIsChecking(true);
    try {
      const response = await fetch('/api/v1/health', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (response.ok) {
        setIsOnline(prevIsOnline => {
          const wasOffline = !prevIsOnline;
          if (wasOffline) {
            // Показываем уведомление о восстановлении подключения
            toast({
              title: t('connection.connection_restored'),
              description: t('connection.offline_mode_description'),
              variant: 'default',
            });
          }
          return true;
        });
        setLastCheck(Date.now());
      } else {
        setIsOnline(prevIsOnline => {
          const wasOnline = prevIsOnline;
          if (wasOnline) {
            // Показываем уведомление о потере подключения
            toast({
              title: t('connection.connection_lost'),
              description: t('connection.server_unavailable_description'),
              variant: 'destructive',
            });
          }
          return false;
        });
      }
    } catch (error) {
      setIsOnline(prevIsOnline => {
        const wasOnline = prevIsOnline;
        if (wasOnline) {
          // Показываем уведомление о потере подключения
          toast({
            title: t('connection.connection_lost'),
            description: t('connection.server_unavailable_description'),
            variant: 'destructive',
          });
        }
        return false;
      });
    } finally {
      setIsChecking(false);
    }
  }, [toast, t]);

  useEffect(() => {
    // Guard against StrictMode double-invocation and keep health check disabled
    if (initialized) return;
    setInitialized(true);
    // Health check is currently disabled; avoid noisy logs
    return undefined;
  }, [initialized]);

  return {
    isOnline,
    isChecking,
    lastCheck,
    checkConnection,
  };
};
